import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import InfoMessages from '../homepage/InfoMessages';
import Documents from '../homepage/Documents';
import moment from 'moment';
import * as i18next from 'i18next';
import { withTranslation } from 'react-i18next';
import { useInfoMessages } from '../../hooks/useInfoMessages';
import Spinner from '../Controls/Spinner';
import { useCountry } from '../../context/CountryContext';
import { defaultLangPerMarket } from '../../constants/flags';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Divider from '@mui/material/Divider';

function InfoMessageView({ match }: RouteComponentProps<{ infoMessageId: string }>) {
    const infoMessageId = parseInt(match.params.infoMessageId);
    const lang = defaultLangPerMarket[useCountry().country];
    const { data: publicMessages = [], isLoading } = useInfoMessages(lang);
    const msg = publicMessages.find((m) => m.infoMessageId === infoMessageId);

    return (
        <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 8 }}>
                {isLoading ? <Spinner /> : msg ? (
                    <Box>
                        <Typography variant="h5" fontWeight={600} gutterBottom>{msg.title}</Typography>
                        <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', p: 2, mb: 2 }}>
                            <Typography variant="body2" color="text.secondary" gutterBottom>
                                {moment(msg.updateDateUTC).format('L')}
                            </Typography>
                            <Divider sx={{ my: 1.5 }} />
                            <Typography sx={{ whiteSpace: 'pre-line', overflowWrap: 'break-word' }}>
                                {msg.message}
                            </Typography>
                        </Paper>
                        <Button
                            component={Link}
                            to={'/infomessages'}
                            variant="text"
                            color="primary"
                            startIcon={<ArrowBackIcon />}
                        >
                            {i18next.t('news.back')}
                        </Button>
                    </Box>
                ) : null}
            </Grid>
            <Grid size={{ xs: 12, md: 4 }} sx={{ display: { xs: 'none', md: 'block' } }}>
                <InfoMessages />
                <Box sx={{ mt: 9 }}>
                    <Documents />
                </Box>
            </Grid>
        </Grid>
    );
}

export default withTranslation('translations')(InfoMessageView);
